import React from "react";
import Sidebar from "../../CoustamComponent/Sidebar";

const WalletHistory = () => {

	return (
		<div class="wrapper dashboard_page ">
			<div class=" page-body d-flex align-items-stretch">
				<div class="page-content">
					<Sidebar />
					<div className="page_wrapper" >
						<div className="container " >
							<div className="row g-3" >

								<div className="col-lg-12" >
									<div className="card  " > 
										 
										 <div className="card-body" > 
											<h4>
											Wallet History
											</h4> 

											<div class="filter-card">
												<div class="row g-2 align-items-end">
													<div class="col-12 col-lg-3">
														<div class="form-group">
															<label> Type   </label>
															<select class="form-control form-select">
																<option value="all">All  </option>
																<option value="buy">  Deposit</option>
																<option value="sell"> Withdraw  </option>
																<option value="sell"> Transfer  </option>
																<option value="sell"> Payoent to a Friend  </option>
																<option value="sell"> Investing  </option>
															</select>
														</div>
													</div>
													<div class="col-6  col-lg-3">
														<div class="form-group">
															<label>Start Date  </label>
															<input type="date" class="form-control"  />
														</div>
													</div>
													<div class="col-6  col-lg-3">
														<div class="form-group">
															<label>End Date</label>
															<input type="date" class="form-control" />
														</div>
													</div>
													<div class="col-lg-3">
														<div class="d-flex gap-2 mt-2 mt-md-0">
															<button class="btn btn-primary-light w-50">Clear</button>
															<button class="btn btn-primary w-50">Apply</button>
														</div>
													</div>
												</div>
											</div>


											<div className="table_data" >
												<div className="table-responsive" >
													<table class="table">
														<thead>
															<tr>
																<th>Request ID</th>
																<th>Status</th>
																<th>Sender account</th>
																<th>Recipient account </th>
																<th>Amount</th>
																<th>Created</th>
																<th></th>
															</tr>
															</thead>
															<tbody>
																<tr class="alt">
																	<td>W14077935</td>
																	<td class="fw-bold text-success">  Complete</td>
																	<td >Wallet(USD)</td>
																	<td >
																	27355053
																	</td>
																	<td >$100.00</td>
																	<td  >
																		02/26/2024
																		<br/>
																		<small>19:27</small>
																	</td>
																	<td  >
																		 <a href=" ">View</a> 
																	</td>
																</tr>
																<tr class="alt">
																	<td>W14077935</td>
																	<td class="fw-bold text-success">  Complete</td>
																	<td >Wallet(USD)</td>
																	<td >
																	27355053
																	</td>
																	<td >$100.00</td>
																	<td  >
																		02/26/2024
																		<br/>
																		<small>19:27</small>
																	</td>
																	<td  >
																		 <a href=" ">View</a> 
																	</td>
																</tr>
															</tbody>
														</table>
												</div>
											</div>


										 </div>

									</div>
								</div> 

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default WalletHistory


